/*=============================
=         Sticky Header       =
=============================*/

window.addEventListener('load', function() {
	// Remove visibility: hidden; for CLS
	body.style = '';

	var stickyHeader = new Waypoint({
		element: main,
		handler: function(direction) {
			var down = direction == 'down';

			if(down)
				body.classList.add('sticky');
			else
				body.classList.remove('sticky');
		},
		offset: 300
	});
});

var lastScrollTop = 0;

window.addEventListener('scroll', function() {
	if(checkWidth(480) && body.classList.contains('sticky') && topbar) {
		var st = window.pageYOffset || document.documentElement.scrollTop;

		if(st > lastScrollTop)
			topbar.classList.add('hide');
		else
			topbar.classList.remove('hide');

		lastScrollTop = st <= 0 ? 0 : st;
	}
});
